import { useEffect, useState } from "react";

function isTooManyRequestsError(error) {
  if (!error) return false;

  const message = String(error.message || "");
  const networkStatusCode = error.networkError?.statusCode;
  const responseStatus = error.networkError?.response?.status;

  return (
    message.includes("429 Too Many Requests") ||
    networkStatusCode === 429 ||
    responseStatus === 429
  );
}

function useRetryOn429({
  error,
  refetch,
  maxRetryCount = 3,
  baseDelayMs = 1500,
}) {
  const [retryCount, setRetryCount] = useState(0);
  const [isAutoRetrying, setIsAutoRetrying] = useState(false);

  useEffect(() => {
    if (
      !error ||
      !isTooManyRequestsError(error) ||
      retryCount >= maxRetryCount
    ) {
      setIsAutoRetrying(false);
      return;
    }

    setIsAutoRetrying(true);
    const timer = setTimeout(() => {
      setRetryCount((count) => count + 1);
      refetch();
    }, baseDelayMs * (retryCount + 1));

    return () => clearTimeout(timer);
  }, [baseDelayMs, error, maxRetryCount, refetch, retryCount]);

  useEffect(() => {
    if (!error) {
      setRetryCount(0);
      setIsAutoRetrying(false);
    }
  }, [error]);

  return { isAutoRetrying, retryCount };
}

export default useRetryOn429;
